import { useEffect as e, useLayoutEffect as t, useState as n } from "react";
import r from "clsx";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/Header/mobile/MenuSlidingPanel.tsx
var s = 150, c = "duration-150", l = ({ isShown: s, shiftLeft: l = !1, direction: u = "rtl", className: d = "", style: f, children: p }) => {
	let [m, h] = n(s), [g, _] = n(s);
	t(() => {
		s && (h(!0), requestAnimationFrame(() => {
			_(!0);
		}));
	}, [s]), e(() => {
		if (!s && m) {
			_(!1);
			let e = setTimeout(() => {
				h(!1);
			}, 150);
			return () => clearTimeout(e);
		}
	}, [s, m]);
	let v;
	return v = g ? u === "rtl" ? l ? "translate-x-none" : "translate-x-[120px]" : "translate-y-none" : u === "rtl" ? "translate-x-full" : "translate-y-full", /* @__PURE__ */ o(i, { children: [/* @__PURE__ */ a("div", {
		className: r(m ? "flex" : "hidden", v, d, "absolute z-2 h-full flex-col gap-3 border-b-1 border-white bg-white ease-in-out", c),
		style: { ...f },
		children: p
	}), /* @__PURE__ */ a("div", { className: "absolute inset-0 -z-1 h-screen w-full bg-white" })] });
};
//#endregion
export { s as MENU_TRANSITION_TIME, c as MENU_TRANSITION_TIME_CLASS, l as MenuSlidingPanel };
